export enum OrigemNFeEntradaEnum {
  Sefaz = 1,
  ImportacaoXml = 2,
  LancamentoManual = 3,
}
